import { Print } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const filesDocuments = [
  { id: 1, name: "แบบคำขอโอนและรับโอน", file: "1.แบบคำขอโอน และรับโอน.pdf" },
  {
    id: 2,
    name: "หนังสือสัญญาซ์้อ - ขายรถ",
    file: "2.หนังสือสัญญาซื้อ-ขายรถยนต์ (ขาย).pdf",
  },
  { id: 3, name: "หนังสือมอบอำนาจ", file: "3.หนังสือมอบอำนาจ.pdf" },
  { id: 4, name: "สัญญารับฝาก", file: "4.หนังสือสัญญารับฝากขาย.pdf" },
  { id: 5, name: "สัญญาจำนำ", file: "5.หนังสือสัญญาจำนำ.pdf" },
];

const PreviewForms = () => {
  const { id } = useParams();
  const [preview, setPreview] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    let file1 = filesDocuments.find((file) => file.id == id);

    setPreview(file1 ?? []);
  }, [id]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          ฟอร์มเอกสาร
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "24px" }}>
          {preview ? preview.name : "แบบคำขอโอนและรับโอน"}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <GradientButtonOutline
          onClick={() => {
            navigate(-1);
          }}
        >
          กลับ
        </GradientButtonOutline>
        <GradientButton
          endIcon={<Print />}
          onClick={() => {
            const link = document.createElement("a");
            link.href = `/assets/files/${preview.file}`;
            link.download = preview.file;
            link.click();
          }}
        >
          ดาวน์โหลดเอกสาร
        </GradientButton>
      </Box>

      <Box
        sx={{
          bgcolor: "rgba(204, 204, 204, 0.65)",
          height: "992px",
          width: "100%",
          borderRadius: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {preview?.file && (
          <img
            src={`/assets/files/previews/${preview.file.replace(
              ".pdf",
              ".png"
            )}`}
            alt={preview.name}
            style={{ maxWidth: "100%" }}
          />
        )}
      </Box>
    </Box>
  );
};
export default PreviewForms;
